export const COMBO_GRID = {
  CELL_CONTENT_WRAPPER: 'combo-grid-cell-content-wrapper',
  ROOT_WRAPPER: 'combo-grid-root-wrapper',
  WRAPPER: 'combo-grid-wrapper',
  TABLE: 'combo-grid-table',
  CELL: 'combo-grid-cell',
  SMART_DURATION: 'combo-grid-smart-duration',
  GRID_EXPAND_ICON: 'combo-grid-expand-icon',
  GRID_EXPAND_ICON_INNER: 'combo-grid-expand-icon-inner',
  ACTION_BUTTONS_WRAPPER: 'combo-grid-action-buttons-wrapper',
  ITEM_WRAPPER: 'combo-grid-item-wrapper',
  ITEM_NAME_WRAPPER: 'combo-grid-item-name-wrapper'
} as const;
